<template>
  <DxDropDownBox
    :element-attr="dropBoxAttributes"
    ref="productSelectBox"
    :placeholder="placeholder"
    :value="gridBoxValue"
    :opened="isGridBoxOpened"
    :defer-rendering="false"
    :display-expr="gridBoxDisplayExpr"
    :show-clear-button="false"
    :data-source="dataSource"
    :remote-operations="isRemoteOperation"
    :cache-enabled="true"
    :class="[
      'combo_with_add',
      { product_control: isGridBoxOpened },
      {
        step_control_error: hasError,
      },
    ]"
    @opened="isGridBoxOpened = true"
    @closed="isGridBoxOpened = false"
    drop-down-button-template="imageIcon"
    :disabled="isComboDisabled"
  >
    <template #imageIcon>
      <div>
        <div class="combo_open_button" v-show="!allowGridAddNewProduct && !hasValueSelected">
          <img src="@/assets/images/icons/plus_green.svg" class="custom-selector-icon" />
        </div>
        <div class="combo_open_button" v-show="allowGridAddNewProduct">
          <img src="@/assets/images/icons/plus_green.svg" class="custom-selector-icon" @click="addNewItemInstant" />
        </div>
        <div class="combo_open_button" v-show="hasValueSelected && !allowGridAddNewProduct">
          <img src="@/assets/images/icons/edit.svg" class="custom-selector-icon" @click="!addNewItemInstant" />
        </div>
      </div>
    </template>
    <template #content>
      <div tabindex="0">
        <DxDataGrid
          :element-attr="gridAttributes"
          ref="productGrid"
          class="product_grid"
          :no-data-text="addNewItemInfoText"
          :data-source="dataSource"
          :show-column-headers="false"
          :hover-state-enabled="true"
          :remote-operations="isRemoteOperation"
          :repaint-changes-only="true"
          :selected-row-keys="gridBoxValue"
          @selection-changed="onGridSelectionChanged($event)"
          @content-ready="onGridContentReady($event)"
          height="100%"
          :columns="comboColumns"
        >
          <DxSelection mode="single" />
          <DxFilterRow :visible="true" />
          <DxScrolling mode="infinite" />
        </DxDataGrid>
      </div>
    </template>
  </DxDropDownBox>
</template>

<script>
import DxDropDownBox from "devextreme-vue/drop-down-box";
import { DxDataGrid, DxColumn, DxSelection, DxFilterRow, DxScrolling } from "devextreme-vue/data-grid";
import DataSource from "devextreme/data/data_source";
import CustomStore from "devextreme/data/custom_store";

export default {
  name: "DxComboWithAdd",
  props: {
    addNewText: {
      type: String,
      default: () => "",
    },
    allowAddNew: {
      type: Boolean,
      default: () => true,
    },
    comboDataset: {
      type: Array,
      default: () => [],
    },
    comboColumns: {
      type: Array,
      default: () => [{ dataField: "name", caption: "Denumire" }],
    },
    hasError: false,
    placeholder: String,
    isComboDisabled: Boolean,
    actionMethod: Function | null,
  },
  data() {
    return {
      gridBoxValue: [],
      isGridBoxOpened: false,
      allowGridAddNewProduct: false,
      dropBoxAttributes: {
        class: "drop_down_with_add",
      },
      gridAttributes: {
        class: "grid_drop_down_with_add",
      },
      selectedItem: null,
    };
  },
  watch: {
    isGridBoxOpened(newVal) {
      this.isGridBoxOpened = newVal;
      if (this.isGridBoxOpened) {
        this.$refs.productGrid.instance.clearFilter();
      }
      this.$set(this, "allowGridAddNewProduct", false);
    },
  },
  computed: {
    hasValueSelected() {
      return this.gridBoxValue && this.gridBoxValue.length > 0;
    },
    addNewItemInfoText() {
      //return '🛈 ' + this.addNewText + ', apasă ➕ pentru a adăuga';
      if (this.allowAddNew) {
        return this.addNewText + ", apasă butonul de adăugare!";
      } else {
        return this.addNewText;
      }
    },
    isRemoteOperation() {
      return this.actionMethod instanceof Function;
    },
    dataSource() {
      if (this.isRemoteOperation) {
        return this.customStore;
      }

      return this.comboDataset;
    },
    customStore() {
      return new DataSource({
        store: new CustomStore({
          key: "uuid",
          load: this.actionMethod,
          byKey: async function (key) {
            return new Promise((resolve) => resolve("success"));
          },
        }),
      });
    },
  },
  components: {
    DxDropDownBox,
    DxDataGrid,
    DxColumn,
    DxSelection,
    DxFilterRow,
    DxScrolling,
  },
  methods: {
    gridBoxDisplayExpr(item) {
      return this.selectedItem?.name ?? item?.name;
    },
    onGridSelectionChanged(e) {
      this.gridBoxValue = e.currentSelectedRowKeys;

      this.isGridBoxOpened = false;
      this.selectedItem = e.selectedRowsData[0];

      if (this.isRemoteOperation) {
        this.$emit("selectionChanged", [this.selectedItem]);
      } else {
        this.$emit("selectionChanged", this.gridBoxValue);
      }
    },
    onGridContentReady(e) {
      if (e.component.getVisibleRows().length <= 0) {
        this.allowGridAddNewProduct = true;
      } else {
        this.allowGridAddNewProduct = false;
      }
    },
    initNewItem(data) {
      this.selectedItem = data;
      this.gridBoxValue = [data.uuid];
      this.$emit("selectionChanged", [data]);
    },
    addNewItemInstant() {
      let gridFilter = this.$refs.productGrid.instance.getCombinedFilter();
      let prodName = gridFilter && gridFilter.filterValue ? gridFilter.filterValue : "";
      this.$emit("addNewItemInstant", prodName);
    },
    updateWithNewItem(newItem) {
      if (newItem != null) {
        this.$refs.productSelectBox.instance.close();
        this.gridBoxValue = [];
        this.gridBoxValue.push(newItem);
      } else {
        this.gridBoxValue = [];
      }
    },
    resetControl() {
      this.gridBoxValue = [];
    },
    setGridSelection(selectItem) {
      this.gridBoxValue = [];
      this.gridBoxValue.push(selectItem);
      this.selectedItem = selectItem;
      this.$nextTick(() => {
        if (this.$refs.productGrid && this.$refs.productGrid.instance) {
          this.$refs.productGrid.instance.refresh();
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/components/dxComboWithAdd.scss";
</style>
